import { AdapterState }  from '@core/interfaces/store.interface';
import { EntityAdapter } from '@ngrx/entity';
import {
	on,
	ReducerTypes
}                        from '@ngrx/store';
import { ActionCreator } from '@ngrx/store/src/models';
import { LoggerService } from '@shared/services/logger.service';
import {
	adapterActions,
	IBaseProps,
	IPropsEntities,
	IPropsEntity,
	IPropsEntityId,
	IPropsEntityIds,
	IPropsEntityMap,
	IPropsUpdateEntities,
	IPropsUpdateEntity
}                        from './adapter.actions';

export function adapterReducer<T, S extends AdapterState<T>>(
	storeId: string,
	adapter: EntityAdapter<T>,
	logger: LoggerService
): ReducerTypes<S, ActionCreator[]>[] {

	return [
		// ADD
		on( adapterActions<T>( storeId ).addMany, ( state, action: IPropsEntities<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:addMany' );
			return {
				...state,
				adapter: adapter.addMany( action.entities, state.adapter )
			};
		} ),

		on( adapterActions<T>( storeId ).addOne, ( state, action: IPropsEntity<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:addOne' );
			return {
				...state,
				adapter: adapter.addOne( action.entity, state.adapter )
			};
		} ),

		// SET
		on( adapterActions<T>( storeId ).setAll, ( state, action: IPropsEntities<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:setAll' );
			return {
				...state,
				adapter: adapter.setAll( action.entities, state.adapter )
			};
		} ),

		on( adapterActions<T>( storeId ).setOne, ( state, action: IPropsEntity<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:setOne' );
			return {
				...state,
				adapter: adapter.setOne( action.entity, state.adapter )
			};
		} ),

		// UPSERT
		on( adapterActions<T>( storeId ).upsertMany, ( state, action: IPropsEntities<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:upsertMany' );
			return {
				...state,
				adapter: adapter.upsertMany( action.entities, state.adapter )
			};
		} ),

		on( adapterActions<T>( storeId ).upsertOne, ( state, action: IPropsEntity<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:upsertOne' );
			return {
				...state,
				adapter: adapter.upsertOne( action.entity, state.adapter )
			};
		} ),

		// UPDATE
		on( adapterActions<T>( storeId ).updateMany, ( state, action: IPropsUpdateEntities<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:updateMany' );
			return {
				...state,
				adapter: adapter.updateMany( action.entitiesUpdateData, state.adapter )
			};
		} ),

		on( adapterActions<T>( storeId ).updateOne, ( state, action: IPropsUpdateEntity<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:updateOne' );
			return {
				...state,
				adapter: adapter.updateOne( action.entityUpdateData, state.adapter )
			};
		} ),

		// REMOVE
		on( adapterActions<T>( storeId ).removeAll, ( state, action: IBaseProps ) => {
			logger?.debug( action.caller + ' | AdapterReducer:removeAll' );
			return {
				...state,
				adapter: adapter.removeAll( { ...state.adapter } )
			};
		} ),

		on( adapterActions<T>( storeId ).removeMany, ( state, action: IPropsEntityIds<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:removeMany' );
			return {
				...state,
				adapter: adapter.removeMany( action.entityIds, state.adapter )
			};
		} ),

		on( adapterActions<T>( storeId ).removeOne, ( state, action: IPropsEntityId<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:removeOne' );
			return {
				...state,
				adapter: adapter.removeOne( action.entityId, state.adapter )
			};
		} ),

		// MAP
		on( adapterActions<T>( storeId ).mapEntity, ( state, action: IPropsEntityMap<T> ) => {
			logger?.debug( action.caller + ' | AdapterReducer:map' );
			return {
				...state,
				adapter: adapter.map( action.entityMap, state.adapter )
			};
		} )
	];
}
